import { useAppDispatch } from '../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import { useAppSelector } from '../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { modalActions, selectModalData } from '../../../entities/Modal'
import { ChangeStateModal } from '../../../shared/ui/ChangeStateModal/ChangeStateModal'
import { deleteApp } from '../model/services/deleteApp'
import { useNavigate } from 'react-router-dom'
import { RoutePath } from '../../../shared/config/routeConfig/routeConfig'

export const DeleteAppModal = () => {

	const dispatch = useAppDispatch()
	const navigate = useNavigate()
	const data = useAppSelector(selectModalData)

	const header = (
		<>
			Please confirm that you want to delete the application
		</>
	)

	const handleConfirm = async () => {
		const result = await dispatch(deleteApp(data.applicationId))
		if (result.meta.requestStatus === 'fulfilled') {
			navigate(RoutePath.applications)
			dispatch(modalActions.hideModal())
		}
	}

	return (
		<ChangeStateModal
			handleConfirm={handleConfirm}
			headerMsg={header}
		/>
	)
}